<template>

    <div :class=" relevantClasses " v-if=" isAuth ">

        {{ loadingStatus || 'loading...' }}
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'network-tab',
        computed: {

            ...mapGetters({

                navOpen       : 'nav/topHeaderOpen',
                isAuth        : 'auth/isAuth',
                isLoading     : 'isLoading',
                loadingStatus : 'loadingStatus'
            }),
            relevantClasses(){

                const base = [ 'base-class' ];
                base.push( ( this.navOpen ) ? 'top-nav-open' : this.isAuth ? 'top-nav-closed' : 'not-auth' );
                base.push( ( this.isLoading || this.loadingStatus != null ) ? '' : 'tab-hidden' );
                base.push( ( this.loadingStatus == null ) ? 'loading' : 'error' );

                return base.join( ' ' );
            }
        }
    }
</script>

<style scoped>

    .base-class {

        display: flex;
        align-items: center;
        padding: 0px 15px;
        position: fixed;
        width: 100%;
        left: 0; right: 0;
        height: 25px;
        color: white;
        font-weight: bold;
        z-index: 50;
        transition: top 0.3s ease-in;
    }
    .not-auth {

        top: 0px;
    }
    .tab-hidden {

        top: -50px !important;
    }
    .top-nav-open {

        top: 235px;
    }
    .top-nav-closed {

        top: 60px;
    }
    .loading {

        background-color: rgba(0, 38, 255, 0.7);
    }
    .error {

        background-color: rgba(235, 20, 20, 0.7);
    }
</style>

